module.exports = __webpack_public_path__ + "img/premio-04.eb5d5d88.png";